export function AVenir({ titre, phase, description }: { titre: string; phase: string; description: string }) {
  return (
    <div className="vide" style={{ textAlign: 'left', padding: '18px 0' }}>
      <p className="sect" style={{ marginTop: 0 }}>
        {titre} <span className="code">{phase}</span>
      </p>
      <p style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--ink2)' }}>{description}</p>
    </div>
  )
}
